import React from 'react'
import { EMPLOYEES_SALARY_DETAIL } from '../../urls'
import { usePutRequest } from '../../hooks/request'
import EmployeeSalaryForm from './EmployeeSalaryForm'

export default function EmployeeSalaryUpdate({ onCancel, onSuccess, item }) {
    const brandUpdate = usePutRequest({ url: EMPLOYEES_SALARY_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <EmployeeSalaryForm loading={brandUpdate.loading} initialValues={item} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
